import styled from 'styled-components'

interface IColumnContainerProps {
  investCard?: boolean
  height?: string
  background?: string
}
interface IHeaderProps {
  investCard?: boolean
  background?: string
  isExpanded?: boolean
}

const ColumnContainer = styled.div<IColumnContainerProps>`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  box-sizing: border-box;
  gap: 8px;
  margin: 0px;
  padding-top: 0;
  border-radius: 5px;
  background-color: #f5f5f5;
  height: ${(props: IColumnContainerProps) => {
    if (props.height) return `${props.height}`
    return `${window.innerHeight - 205}px`
  }};
  min-width: ${(props: IColumnContainerProps) => {
    if (props.investCard) return '292px'
    return '246px'
  }};
`

const Header = styled.div<IHeaderProps>`
  background-color: ${({ theme }) => theme.colors.primary};
  padding: 8px 16px;
  padding-right: 8px;
  color: #ffffff;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  display: flex;
  transition: all 0.3s;
  height: ${(props: IHeaderProps) => (props.isExpanded ? '76.96px' : '42px')};
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  gap: 8px;
  position: relative;
  overflow: hidden;
  .column-header-content {
    display: flex;
    justify-content: space-between; /* distribui espaço entre nome+contador e botão */
    align-items: center;
    width: 100%;
    gap: 8px;
  }
  .icon-kanban {
    width: 12px;
    height: 12px;
  }
  .expand-kanban {
    display: flex;
    justify-content: center;
    align-items: center;
    background: transparent;
    border: none;
    cursor: pointer;
    justify-self: flex-end;
  }
  .column-name {
    display: flex;
    align-items: center;
    align-self: center;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: 26px;
    letter-spacing: 0.02px;
    text-align: left;
    color: #ffffff;
  }
  .totalValue {
    position: absolute;
    left: 16px;
    top: 42.36px;
    color: #ffffff;
    font-weight: 700;
    font-size: 18px;
    letter-spacing: 0.02px;
    font-family: 'roboto';
  }
  .filter-icon {
    filter: brightness(0) invert(1);
  }
`
export { ColumnContainer, Header }
